/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// redux
// import { NoDataState } from 'react-redux';
// material
// import AsideToggle from '../sidebar/controls/asidetoggle/asidetoggle';
// styles
import injectSheet from 'react-jss';
import styles from './nodata_styles';



/* ========== ~~~~~~~~~~ NO DATA - STATE ~~~~~~~~~~ ========== */
const NoDataState = injectSheet(styles)((props) => {
	return (
		<div className={`nodatastate ${props.classes.nodatastate} variant-${props.variant}`}>
			<div className={'content'}>
				{/*<div className={'graphic'}></div>*/}
				<div className={'desc'}>
					{props.title && <h2>{props.title}</h2>}
					{/*<h3>Not enough data</h3>*/}
					<p>Unfortunately, there's not enough data to display this chart.</p>
					<p className={'note'}><em>* You may want to select different dates from the Date range dropdown.</em></p>
				</div>
			</div>
		</div>
	);
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default NoDataState;
